import { useMutation, useQuery, useQueryClient } from 'react-query'
import * as api from 'shared/api/notifications'
import { CompanyUser } from 'shared/context/CompanyContext'

export const notificationKey = (user: CompanyUser) => ['notifications', user.organization, user.id]
export const canSeeNotifications = (user: CompanyUser) => Boolean(user.can_manage_issues && !user.is_staff)
export const notificationPolling = {
  retry: false,
  refetchInterval: 60000,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: 'always' as const,
}

export function useUnreadNotifications(user: CompanyUser, type?: api.NotificationType) {
  return useQuery([...notificationKey(user), 'count', type], () => api.getUnreadCount(type), {
    ...notificationPolling,
    enabled: canSeeNotifications(user),
  })
}

export function useReadNotifications(user: CompanyUser) {
  const cache = useQueryClient()
  return useMutation(api.markNotificationsRead, {
    onSuccess: () => {
      void Promise.all([
        cache.invalidateQueries(notificationKey(user)),
        cache.invalidateQueries(['carrier-inbox', user.organization, user.id]),
        cache.invalidateQueries(['carrier-inbox-email', user.organization, user.id]),
        cache.invalidateQueries(['work-issues', user.organization, user.id]),
        cache.invalidateQueries(['work-issue', user.organization, user.id]),
      ])
    },
  })
}
